(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["image-protection"] && !Shopify.designMode) return;
  try {
    (() => {
    // A single delegated listener on document covers every image on the
    // page - present now or added later (carousels, quick-add, section
    // reloads in the theme editor) - with nothing to reinitialise.
    if (document.documentElement.dataset.imageProtectionInitialized) return;
    document.documentElement.dataset.imageProtectionInitialized = 'true';

    document.addEventListener('contextmenu', (event) => {
      if (event.target instanceof Element && event.target.closest('img')) {
        event.preventDefault();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
